export interface UserSettings {
    userId: string;
    recordViewsFoldersExpanded: boolean;
    settings: { [key: string]: any };
}

export enum ViewsOpeningOption {
    SameTab = "sameTab",
    NewTab = "newTab"
}

export enum CaseCloseOption {
    StayOnCase = "stayOnCase",
    RedirectToDashboard = "redirectToDashboard"
}
